/**
 * Determine the content of tooltip for a control. May return empty string, meaning tooltip doesn't need to be shown.
 * @param isLabelShown Whether the label for the control is currently shown
 * @param label The label text for the control
 * @param customTooltip The custom tooltip text for the control
 */
export function getTooltipText(isLabelShown: boolean, label: string, customTooltip: string | undefined): string {
  if (isLabelShown) {
    // If label is shown, only display tooltip if it has different text than the label (with `customTooltip`).
    if (customTooltip && customTooltip !== label) {
      return customTooltip;
    }
    return '';
  }
  // Label is hidden, show the tooltip
  return customTooltip || label;
}
